<template>
  <div class="methodology_slider" :ref="name"></div>
  
  <div class="methodology-slider-container" v-for="(result,r) in computedData" :key="result.title">
    <div class="methodology-slider-card" v-if="r === slider_val">
      <div class="methodology-slider-title" v-html="result.title"></div>
      <div class="methodology-slider-body" v-html="result.body"></div>
    </div>
  </div>
</template>

<script>
  import * as noUiSlider from 'nouislider';
	import 'nouislider/dist/nouislider.css';

  export default {
    name: 'MethodologySlider',

    props: {
    	name: {
    		type: String
    	}
    },

    data() {
      return {
        slider_val: false,
        'impact': [
          {
            title: '"Just Starting"',
            body: `<p>Organisations in this category are just starting out. Their current reach is relatively low.</p>`
          },
          {
            title: '"Local"',
            body: `<p>Organisations in this category mostly operate within a single Town or City. Their consumer reach is often greater but c. 90% of their customers are localised.</p>`
          },
          {
            title: '"National"',
            body: `<p>Organisations in this category have nationwide operations. They typically have operations and team members across multiple domestic locations.</p>`
          },
          {
            title: '"Transnational"',
            body: `
              <p>Organisations in this category operate transnationally.</p>
              <p>They typically have operations and team members in 2 - 5 countries.</p>`
          },
          {
            title: '"Global"',
            body: `
              <p>Organisations in this category have a truly global customer base.</p>
              <p>They typically have operations and team members spread across different locations in 5 or more countries.</p>`
          },
        ],
        'planet': [
          {
            title: '"Work in progress"',
            body: `<p>These organisations have few environmental policies in place at present.</p>`
          },
          {
            title: '"Conscientious of the planet"',
            body: `<p>These organisation are explicitly working towards becoming planet-neutral and have goals and deadlines to meet those goals to improve their environmental practices.</p>`
          },
          {
            title: '"Low Impact"',
            body: `<p>These organisations' business models and operations inherently are low impact  e.g. Digital Services, Agencies, Consultancies. This includes fully remote teams which don't require frequent travel or excessive production.</p>`
          },
          {
            title: '"Great"',
            body: `<p>These organisations' environmental impact are largely positive, they have a number of solid environmental policies, measurements and goals that they are actively working towards.</p>`
          },
          {
            title: '"Exceptional"',
            body: `<p>These organisations are actively making a positive environmental impact on the world. Things taken into account: the impact of their product or service on the environment, their energy use and source, their recycling programmes, and their measurement and proactive mitigation of any emissions.</p>`
          },
        ],
        'mission': [
          {
            title: '"Other"',
            body: `<p>This organisation’s primary purpose is to solve a problem which we do not support.</p>
                  <p>For more information on how we categorise an organisation's mission, view our latest <a href="https://docs.google.com/spreadsheets/d/1EwMr_KwUtEN8YnlKs8enI9CspGB-pYtgPg9KVT3UWfk/edit?usp=sharing" target="_blank" rel="noreferrer">"Missions We Support: 2021" list.</a></p>`
          },
          {
            title: '"Better Business"',
            body: `<p>This organisation’s primary purpose is to solve a problem which we support.</p>
                  <p>For more information on how we categorise an organisation's mission, view our latest <a href="https://docs.google.com/spreadsheets/d/1EwMr_KwUtEN8YnlKs8enI9CspGB-pYtgPg9KVT3UWfk/edit?usp=sharing" target="_blank" rel="noreferrer">"Missions We Support: 2021" list.</a></p>`
          },
          {
            title: '"Business For Good"',
            body: `<p>This organisation is working towards solving an important problem that falls outside of the United Nations Sustainable Development Goals.</p>
                  <p>For more information on how we categorise an organisation's mission, view our latest <a href="https://docs.google.com/spreadsheets/d/1EwMr_KwUtEN8YnlKs8enI9CspGB-pYtgPg9KVT3UWfk/edit?usp=sharing" target="_blank" rel="noreferrer">"Missions We Support: 2021" list.</a></p>`
          },
          {
            title: '"Supporting a Better Future"',
            body: `<p>This organisation's work is contributing towards solving one or more of the problems as identified by the United Nation Sustainable Development Goals, but it is not explicitly their primary purpose.</p>
                  <a href="https://sustainabledevelopment.un.org/" target="_blank">
                    <img alt="" src="/images/methodology/mission-scale.jpg">
                  </a>
                  <p>Click on the image above to find out more.</p>`
          },
          {
            title: '"Fixing The Future"',
            body: `<p>This organisation’s primary purpose is to solve a problem identified in one of the 17 United Nation Sustainable Development Goals.</p>
                  <a href="https://sustainabledevelopment.un.org/" target="_blank">
                    <img alt="" src="/images/methodology/mission-scale.jpg">
                  </a>
                  <p>Click on the image above to find out more.</p>`
          },
        ], 
        'innovation': [
          {
            title: '"Challenger"',
            body: `<p>These organisations are doing things differently through their methods, customers, operations, HR or business practices.</p>`
          },
          {
            title: '"Disruptor"',
            body: `<p>These organisations are part of a small but growing group of organisations doing things differently in their industry.</p>`
          },
          {
            title: '"Game changer"',
            body: `<p>The only (one of a select few) highly disruptive organisation(s) in their industry. They have a completely unique approach to solving a problem.</p>`
          }
        ], 
        'b-corp': [
          {
            title: '"Not B-Corp Certified"',
            body: `<p>The organisation is not B-Corp Certified.</p>`
          },
          {
            title: '"Charity"',
            body: `<p>This organisation is a charity, and therefore is not eligible for B Corp certification.</p>`
          },
          {
            title: '"B-Corp Certified"',
            body: `<p>The organisation is B-Corp Certified.</p>`
          },
        ],
      }
    },

    mounted() {
      this.sliderInit();
      this.computedRef.noUiSlider.on('update', this.sliderUpdate);
    },

    methods: {
      sliderInit() {
        noUiSlider.create(this.computedRef, {
            start: 0,
            step: 1,
            range: {
                min: 0,
                max: this.computedData.length -1
            }
        });
      },
      sliderUpdate(values, handle) {
        this.slider_val = parseInt(values[handle]);
      }
    },

    computed: {
      computedRef() {
        return this.$refs[this.name]
      },
      computedData() {
        return this[this.name];
      }
    }
  };
</script>
